import * as React from "react"

const SvgComponent = (props) => (
  <svg
    id="a"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 165.71 160"
    {...props}
  >
    <defs>
      <style>{".b{fill:#fff}"}</style>
    </defs>
    <path
      className="b"
      d="M148.57 0H17.14C7.69 0 0 7.69 0 17.14v80c0 9.45 7.69 17.14 17.14 17.14h14.29a2.86 2.86 0 1 0 0-5.72H17.14c-6.3 0-11.43-5.13-11.43-11.43V17.14c0-6.3 5.13-11.43 11.43-11.43h131.43c6.3 0 11.43 5.13 11.43 11.43v80c0 6.3-5.13 11.43-11.43 11.43h-14.29a2.86 2.86 0 1 0 0 5.72h14.29c9.45 0 17.14-7.69 17.14-17.14V17.14c0-9.45-7.69-17.14-17.14-17.14Z"
    />
    <path
      className="b"
      d="M144.02 14.84 89.76 54.82c-4.29 3.09-12.38 3.09-16.64.02l-54.28-40a2.84 2.84 0 0 0-3.99.61 2.84 2.84 0 0 0 .61 3.99l54.31 40.02c3.16 2.28 7.41 3.42 11.66 3.42s8.53-1.14 11.7-3.44l54.29-40c1.27-.93 1.54-2.72.61-3.99a2.858 2.858 0 0 0-3.99-.61ZM20 97.14c.73 0 1.46-.28 2.02-.84l34.29-34.28a2.849 2.849 0 0 0 0-4.04 2.849 2.849 0 0 0-4.04 0L17.98 92.27a2.849 2.849 0 0 0 0 4.04c.56.56 1.29.84 2.02.84ZM113.45 57.98a2.849 2.849 0 0 0-4.04 0 2.849 2.849 0 0 0 0 4.04l34.29 34.29a2.848 2.848 0 0 0 4.04 0 2.849 2.849 0 0 0 0-4.04l-34.29-34.29ZM82.86 74.29C59.23 74.29 40 93.51 40 117.15s19.22 42.86 42.86 42.86c11.5 0 22.29-4.49 30.4-12.65a2.858 2.858 0 0 0-.01-4.04 2.867 2.867 0 0 0-4.04.01c-7.03 7.07-16.38 10.96-26.35 10.96-20.48 0-37.14-16.66-37.14-37.14s16.66-37.14 37.14-37.14S120 96.67 120 117.15c0 10.13-4.58 11.43-8.57 11.43-7.95 0-8.57-8.75-8.57-11.43 0-11.03-8.97-20-20-20s-20 8.97-20 20 8.97 20 20 20c7.14 0 13.41-3.78 16.95-9.43 2.29 3.87 6.1 6.57 11.63 6.57s14.29-2.23 14.29-17.14c0-23.63-19.22-42.86-42.86-42.86Zm0 57.14c-7.88 0-14.29-6.41-14.29-14.29s6.41-14.29 14.29-14.29 14.29 6.41 14.29 14.29-6.41 14.29-14.29 14.29Z"
    />
  </svg>
)

export default SvgComponent
